import React from 'react';

const TabsContext = React.createContext({
  activeTab: '',
  setActiveTab: () => {},
});

export const Tabs = ({ children, value, onValueChange, defaultValue }) => {
  const isControlled = typeof value !== 'undefined';
  const [internalActiveTab, setInternalActiveTab] = React.useState(defaultValue);

  const activeTab = isControlled ? value : internalActiveTab;
  const setActiveTab = (next) => {
    if (isControlled) {
      if (onValueChange) onValueChange(next);
    } else {
      setInternalActiveTab(next);
    }
  };

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>
      <div className="space-y-2">
        {children}
      </div>
    </TabsContext.Provider>
  );
};

export const TabsList = ({ children }) => {
  return (
    <div className="inline-flex h-10 items-center justify-center rounded-md bg-gray-100 p-1">
      {children}
    </div>
  );
};

export const TabsTrigger = ({ children, value }) => {
  const { activeTab, setActiveTab } = React.useContext(TabsContext);
  const isActive = activeTab === value;

  return (
    <button
      type="button"
      className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all focus:outline-none disabled:pointer-events-none disabled:opacity-50 ${
        isActive
          ? 'bg-white text-gray-900 shadow-sm'
          : 'text-gray-600 hover:text-gray-900'
      }`}
      onClick={() => setActiveTab(value)}
    >
      {children}
    </button>
  );
};

export const TabsContent = ({ children, value }) => {
  const { activeTab } = React.useContext(TabsContext);

  if (value !== activeTab) return null;

  return (
    <div className="mt-2 focus:outline-none">
      {children}
    </div>
  );
};
